module.exports = __webpack_public_path__ + "static/media/jasperchen.68ec7aca.jpeg";